import { forwardRef, type Ref, type SVGProps } from "react";
const IconTagFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M28.003 2h-10a1.97 1.97 0 0 0-1.41.59l-14 14a1.974 1.974 0 0 0 0 2.82l10 10a1.98 1.98 0 0 0 2.82 0l14-14c.378-.371.591-.88.59-1.41V4a2.006 2.006 0 0 0-2-2m-4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTagFilledSVG);
ForwardRef.displayName = "IconTagFilled";
export { ForwardRef as IconTagFilled };
